import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowGrowthIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.92 6.62a1.0002 1.0002 0 0 0-.54-.54A.9998.9998 0 0 0 21 6h-5a1 1 0 1 0 0 2h2.59L13 13.59l-3.29-3.3A1.001 1.001 0 0 0 9 9.9942a.9994.9994 0 0 0-.71.2958l-6 6a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9994.9994 0 0 0 .71-.2958L9 12.41l3.29 3.3a.9997.9997 0 0 0 1.42 0L20 9.41V12a1.0001 1.0001 0 0 0 2 0V7a1.0011 1.0011 0 0 0-.08-.38Z"/>
  </SvgIcon>
}

export default LineArrowGrowthIcon
